"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMunchkin = void 0;
const Attribution_1 = require("./Attribution");
// generate random cookie id
const randomid = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const l = 40;
    let ret = '';
    for (let i = 0; i < l; ++i) {
        ret += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return ret;
};
const attribution = new Attribution_1.default();
const getMunchkin = (eventName) => {
    // check vero_user exists
    const cookieId = attribution.get_cookie(eventName);
    if (!cookieId) {
        // if not exists, create a random id
        const id = randomid();
        // store id in cookies
        attribution.set_cookie(eventName, id);
        return attribution.get_cookie(eventName);
    }
    return cookieId;
};
exports.getMunchkin = getMunchkin;
